// Mock data for Sondr Landing Page

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "VP of Sales, TechFlow Inc",
    company: "TechFlow Inc",
    content: "Sondr transformed our dead leads into $400K in recovered revenue in just 3 months. The AI-powered SMS approach was a game-changer for our sales team.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop",
    stats: "$400K recovered"
  },
  {
    id: 2,
    name: "James Rodriguez",
    role: "Founder, GrowthLab",
    company: "GrowthLab",
    content: "We were skeptical at first about the performance-based model, but Sondr delivered. 67% of our cold leads became active conversations within 2 weeks.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop",
    stats: "67% reactivation rate"
  },
  {
    id: 3,
    name: "Emily Chen",
    role: "CMO, CloudSpace",
    company: "CloudSpace",
    content: "The best part? We only pay when we see results. Sondr's AI knows exactly when and how to reach out, making every message count.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop",
    stats: "3x ROI"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What does 'performance-based' mean?",
    answer: "You only pay when we convert your dead leads into actual sales conversations or meetings. If we don't deliver results, you don't pay. It's that simple."
  },
  {
    id: 2,
    question: "How does the AI know when to reach out?",
    answer: "Our AI analyzes lead behavior, engagement patterns, and optimal timing windows to send personalized SMS messages at the exact moment they're most likely to respond. It learns and improves with every interaction."
  },
  {
    id: 3,
    question: "What types of businesses work best with Sondr?",
    answer: "Sondr works best for B2B and B2C companies with high-ticket products or services ($1,000+) who have accumulated cold leads over time. This includes SaaS, consulting, real estate, financial services, and professional services."
  },
  {
    id: 4,
    question: "How long does it take to see results?",
    answer: "Most clients start seeing reactivated leads within the first 7-14 days. Full campaign results typically materialize within 30-60 days as our AI optimizes messaging and timing."
  },
  {
    id: 5,
    question: "Is SMS marketing compliant with regulations?",
    answer: "Absolutely. We ensure full compliance with TCPA, GDPR, and all relevant SMS marketing regulations. We only contact leads who have previously engaged with your business and opted in to communications."
  },
  {
    id: 6,
    question: "What's included in the service?",
    answer: "We provide complete end-to-end service: AI-powered lead analysis, personalized SMS campaign creation, message sending, conversation management, and detailed analytics dashboards. You just provide the leads and watch them convert."
  }
];

export const features = [
  {
    id: 1,
    title: "AI-Powered Personalization",
    description: "Every message is uniquely crafted based on lead history, behavior, and preferences. No generic templates.",
    icon: "Brain"
  },
  {
    id: 2,
    title: "Smart Timing Optimization",
    description: "Our AI determines the perfect moment to reach out, maximizing response rates and engagement.",
    icon: "Clock"
  },
  {
    id: 3,
    title: "Two-Way Conversations",
    description: "Real human-like conversations powered by AI that can answer questions and qualify leads automatically.",
    icon: "MessageSquare"
  },
  {
    id: 4,
    title: "Performance-Based Pricing",
    description: "Pay only for results. No upfront costs, no monthly retainers. You win, we win.",
    icon: "TrendingUp"
  },
  {
    id: 5,
    title: "Real-Time Analytics",
    description: "Track every message, response, and conversion in real-time with our intuitive dashboard.",
    icon: "BarChart3"
  },
  {
    id: 6,
    title: "Compliance Guaranteed",
    description: "100% compliant with TCPA, GDPR, and all SMS marketing regulations. Rest easy knowing you're protected.",
    icon: "Shield"
  }
];

export const howItWorks = [
  {
    id: 1,
    step: "01",
    title: "Share Your Dead Leads",
    description: "Upload your cold lead list or integrate with your CRM. We'll analyze each lead's history and potential."
  },
  {
    id: 2,
    step: "02",
    title: "AI Analyzes & Personalizes",
    description: "Our AI studies each lead's behavior, preferences, and engagement history to craft personalized outreach strategies."
  },
  {
    id: 3,
    step: "03",
    title: "Smart SMS Campaigns Launch",
    description: "Automated, personalized SMS messages are sent at optimal times with follow-ups based on responses."
  },
  {
    id: 4,
    step: "04",
    title: "You Get Qualified Leads",
    description: "Receive warm, qualified leads ready for your sales team. You only pay when leads convert to conversations."
  }
];

export const stats = [
  {
    id: 1,
    value: "67%",
    label: "Average Lead Reactivation Rate"
  },
  {
    id: 2,
    value: "$2.4M+",
    label: "Revenue Recovered for Clients"
  },
  {
    id: 3,
    value: "48hrs",
    label: "Average Response Time"
  },
  {
    id: 4,
    value: "98%",
    label: "Client Satisfaction Score"
  }
];